export default {
  SWAN_RECORD_NOT_FOUND: "SWAN_RECORD_NOT_FOUND",
};
